export const defaultStyles = {
  container: "default",
  backgroundColor: "var(--theme-website-color-background-primary)",
  borderWidth: "0",
  borderColor: "var(--theme-website-color-border-primary)",
  borderRadius: {
    border_left_top_radius: "0",
    border_left_bottom_radius: "0",
    border_right_top_radius: "0",
    border_right_bottom_radius: "0",
  },
  borderStyle: "solid",
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
  padding: {
    paddingTop: "32",
    paddingBottom: "32",
    paddingLeft: "32",
    paddingRight: "32",
  },
} as const;
